const isDev =false
export const API_HOST = isDev ? "http://localhost:8080" :  "https://twitter-clone-sizz.herokuapp.com";
export const TOKEN = "token";
